import { render, staticRenderFns } from "./warning-edit-modal.vue?vue&type=template&id=38581b6a&scoped=true&"
import script from "./warning-edit-modal.vue?vue&type=script&lang=js&"
export * from "./warning-edit-modal.vue?vue&type=script&lang=js&"
import style0 from "./warning-edit-modal.vue?vue&type=style&index=0&id=38581b6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38581b6a",
  null
  
)

export default component.exports